import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { parseQueryParams } from '@lwtears/lwt-common-frontend/lib/@common/util/query-params-util';
import useUserStore from 'graph/state/query-hooks/use-user';
import { Settings } from 'types';

const AppLoadListeners: React.FunctionComponent<React.PropsWithChildren> = (props) => {
  const navigate = useNavigate();
  const [{ me, isAuthenticated }, { setDefaultCurriculumCode }] = useUserStore();
  const queryParams = parseQueryParams();

  useEffect(() => {
    const curriculum = queryParams?.curriculum;
    if (curriculum) setDefaultCurriculumCode(curriculum);
  }, [queryParams?.curriculum, setDefaultCurriculumCode]);

  const shouldDisplayTour = () => {
    if (!me) return false;

    const welcomeSettings = me.toursSettings?.find((v) => v.tour?.name === Settings.WELCOME);
    if (!welcomeSettings) return true;
    if (welcomeSettings.tourStepSettings.length === 0) return true;

    for (const stepSetting of welcomeSettings.tourStepSettings) {
      if (!stepSetting.viewed) return true;
    }

    return false;
  };

  useEffect(() => {
    if (!isAuthenticated) return;

    sessionStorage.setItem('userID', me!.id.toString());

    if (shouldDisplayTour()) navigate('/home?tour=true');
  }, [me]);

  return <>{props.children}</>;
};

export default AppLoadListeners;
